import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["saveButton", "warning"];
  }

  static get outlets() {
    return ["tiptap"];
  }

  connect() {
    if (this.hasTiptapOutlet) {
      this.tiptapOutlet.element.addEventListener("tiptap:ready", () => {
        this.editor = this.tiptapOutlet.editor;
        this.editor.on("update", () => {
          this.showWarning()
          this.enableSaveButton();
        });
      });
    }
    $.uf.dropzoneS3(".dropzone-target", ".dropzone-template", ".dropzone-previews", "/file_uploads", { maxFiles: null, clickable: ".fileinput-button" });
  }

  showWarning() {
    if (this.hasWarningTarget) {
      this.warningTarget.style.display = "inline-block";
    }
  }

  enableSaveButton() {
    if (this.hasSaveButtonTarget) {
      this.saveButtonTarget.removeAttribute("disabled");
    }
  }
}